import { useMemo, useState } from "react";
import { InvoiceExportRepositoryImpl } from "../../data/repositories/InvoiceExportRepositoryImpl";
import { DownloadInvoiceExportExcelUseCase } from "../../domain/use-cases/invoices/DownloadInvoiceExportExcelUseCase";

const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const useInvoiceExcelExport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  const useCase = useMemo(() => {
    const repo = new InvoiceExportRepositoryImpl();
    return new DownloadInvoiceExportExcelUseCase(repo);
  }, []);

  const download = async (params?: { fromDate?: string; toDate?: string }) => {
    try {
      setError("");
      setLoading(true);
      const entity = await useCase.execute(params);
      downloadBlob(entity.blob, entity.filename);
    } catch (e: any) {
      setError(e?.message || "Failed to download invoice export.");
      throw e;
    } finally {
      setLoading(false);
    }
  };

  return { download, loading, error };
};

